import { ReactNode } from 'react';
import Link from '@alltrails/denali/components/Link';
import Typography from '@alltrails/core/components/Typography';
import { FormattedMessage } from 'react-intl';
import Logo from '@alltrails/denali/components/Logo';
import RegisterForm from '../RegisterForm';
import TermsOfService from '../TermsOfService';
import LoginResponse from '../../types/LoginResponse';
import styles from './SignUpModal.module.scss';

// Desktop: https://www.figma.com/file/gZaqAej8HzoFkyrjlQ4cNs/Integrating-Brand-Changes?node-id=6514%3A99348
// Mobile: https://www.figma.com/file/gZaqAej8HzoFkyrjlQ4cNs/Integrating-Brand-Changes?node-id=6514%3A99372

type RegisterProps = {
  heading?: ReactNode;
  onLogInClick: () => void;
  onSuccess: ({ user }: LoginResponse) => void;
  grantType?: string | null;
};

const Register = ({ heading, onLogInClick, onSuccess, grantType }: RegisterProps) => {
  return (
    <div className={styles.content}>
      <div className={styles.logo}>
        <Logo variant="symbol" size="lg" color="monochrome-dark" />
      </div>
      <Typography component="div" variant="heading400" className={styles.header}>
        {heading || <FormattedMessage defaultMessage="To keep exploring trails, log in or sign up for free" />}
      </Typography>
      <div className={styles.form}>
        <RegisterForm autoFocus handleRegistrationSuccess={onSuccess} grantType={grantType} />
      </div>
      <Typography component="div" mb="32" variant="paragraph200" color="secondary">
        <FormattedMessage defaultMessage="Already have an account?" />{' '}
        <Link size="md" onClick={onLogInClick}>
          <FormattedMessage defaultMessage="Log in" />
        </Link>
      </Typography>
      <TermsOfService />
    </div>
  );
};

export default Register;
